import { SurveyActionBar } from "survey-react-ui";
import { Button, Card } from "../../../ui/src";
import { Action } from "survey-core";

export class ActionCard extends SurveyActionBar {
  renderElement() {
    if (!this.model.hasActions) return null;

    const primary: Action[] = [];
    const secondary: Action[] = [];
    const hasCompleteAction = this.model.renderedActions.some(
      (action: Action) => action.id === "sv-nav-complete" && action.visible,
    );

    this.model.renderedActions.forEach((action: Action) => {
      if (!action.visible) return;
      if (hasCompleteAction && action.id === "sv-nav-next") return;
      const isPrimary =
        action.id === "sv-nav-next" || action.id === "sv-nav-complete";
      (isPrimary ? primary : secondary).push(action);
    });
    return (
      <Card title="Acties">
        <div
          style={{
            display: "flex",
            gap: 10,
            width: "100%",
            flexDirection: "column",
          }}
        >
          {secondary.map((action) => this.renderAction(action))}

          {primary.map((action) => this.renderAction(action, true))}
        </div>
      </Card>
    );
  }

  private renderAction(action: Action, isPrimary?: boolean) {
    return (
      <Button
        key={action.renderedId}
        type={isPrimary ? "primary" : "default"}
        disabled={!action.enabled}
        onClick={() => action.action()}
        style={{ width: "100%" }}
      >
        {action.title}
      </Button>
    );
  }
}
